import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivationActivateAccountComponent } from './components/activation-activate-account/activation-activate-account.component';
import { ActivationLinkExpiredComponent } from './components/activation-link-expired/activation-link-expired.component';
import { AuthActionSuccessfulComponent } from './components/auth-action-successful/auth-action-successful.component';
import { ActivationAccountActivatedComponent } from './components/activation-account-activated/activation-account-activated.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { PasswordResetComponent } from './components/password-reset/password-reset.component';
import { TokenSentComponent } from './components/token-sent/token-sent.component';
import { ConfirmLogoutComponent } from './components/confirm-logout/confirm-logout.component';
import { NgOtpInputModule } from  'ng-otp-input';
import { OtpEntryComponent } from './components/otp-entry/otp-entry.component';
import { ResendAuthOtpComponent } from './components/resend-auth-otp/resend-auth-otp.component';
import { NonCitizenAccountActivationComponent } from './components/common-auth-components/non-citizen-account-activation/non-citizen-account-activation.component';
import { NonCitizenResendActivationOtpComponent } from './components/common-auth-components/non-citizen-resend-activation-otp/non-citizen-resend-activation-otp.component';
import {UtilsModule} from "@zikata-frontend/util";
import {
  CommonResetPasswordComponent
} from "./components/common-auth-components/common-reset-password/common-reset-password.component";

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgOtpInputModule, UtilsModule],
  declarations: [
    ActivationActivateAccountComponent,
    ActivationLinkExpiredComponent,
    AuthActionSuccessfulComponent,
    ActivationAccountActivatedComponent,
    OtpEntryComponent,
    ResendAuthOtpComponent,
    ForgotPasswordComponent,
    PasswordResetComponent,
    TokenSentComponent,
    ConfirmLogoutComponent,
    NonCitizenAccountActivationComponent,
    NonCitizenResendActivationOtpComponent,
    CommonResetPasswordComponent
  ],
  exports: [
    ActivationActivateAccountComponent,
    ActivationLinkExpiredComponent,
    AuthActionSuccessfulComponent,
    ActivationAccountActivatedComponent,
    OtpEntryComponent,
    ResendAuthOtpComponent,
    ForgotPasswordComponent,
    PasswordResetComponent,
    TokenSentComponent,
    ConfirmLogoutComponent,
    NonCitizenAccountActivationComponent,
    NonCitizenResendActivationOtpComponent,
    CommonResetPasswordComponent
  ],
})
export class AuthModule {}
